<template>
    <div class="idea-challenges">
      <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
      <transition name="fade">
        <div v-if="contentReady && contentLoadError === ''">
          <ContentHeader :name="award.title.rendered"></ContentHeader>
          <section>
            <div class="card mb-3">
              <div v-if="award._embedded['wp:featuredmedia'] !== undefined" class="featuredImg">
                <img v-if="award._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
                  :src="award._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
                  :alt="award._embedded['wp:featuredmedia'][0].alt_text"
                  :title="award._embedded['wp:featuredmedia'][0].title.rendered"
                >
              </div>
              <div v-html="award.content.rendered" class="card-body px-3 pb-0"></div>
              <div v-if="award.nomination_event_time_frame.length > 0">
                <ul class="fa-ul" v-if="award.nomination_event_time_frame[0][0][0].nomination_event_date_from !== ''">
                  <li class="h6">
                    <span class="fa-li"><i class="fas fa-calendar-alt fa-fw fa-sm text-black-50"></i></span>
                    {{award.nomination_event_time_frame[0][0][0].nomination_event_date_from}} -
                    {{award.nomination_event_time_frame[0][0][0].nomination_event_date_to}}
                  </li>
                </ul>
              </div>
              <!-- <ChildNominationEventsList v-if="award.child_nomination_awards.length > 0 && award.child_nomination_awards[0] !== []" class="px-3 pb-3" :awards="award.child_nomination_awards[0][0]" name="The awards categories are:"></ChildNominationEventsList> -->
              <div v-if="madeNomination" class="px-3 pb-3">
                <div class="alert alert-success" role="alert">
                  Congratulations, you've nominated:
                  <ul>
                    <li v-for="teams in NominationTeamNames" v-bind:key="teams.email">
                        <strong>{{teams.name}}</strong> from {{teams.country}} -
                        Employee number: <strong>{{teams.employeeNum}}</strong><br>
                        Department: <strong>{{teams.department}}</strong><br>
                        Company: <strong>{{teams.company}}</strong><br>
                    </li>
                  </ul>
                </div>
                <button type="button" name="button" class="btn btn-primary" v-on:click="removeNominee()">Nominate someone else</button>
              </div>
              <div v-if="award.include_nomination_form[0] === 'Yes' && award.nomination_fields.length > 0 && !madeNomination" class="px-3 pb-3">
                <h4 class="mb-3">{{NominationLabel}}</h4>
                <form v-on:submit.prevent=""><!-- Added OnSubmit; after few plugins update issues -->
                  <div class="input-group input-group-lg mb-4">
                    <vue-bootstrap-typeahead class="form-control" v-model="nominatedPerson" :data="nomineesList" @keydown.enter="search" :serializer="item => item.email" placeholder="Search by email address" prepend="" ></vue-bootstrap-typeahead>
                    <!-- <input type="text" class="form-control" :placeholder="NominationPlaceholder" v-model="nominatedPerson" required> -->
                    <div class="input-group-append">
                      <button class="btn btn-primary" type="submit" :disabled="nominatedPerson.length === 0" v-on:click="setNominee()">{{NominationButtonText}}</button>
                    </div>
                  </div>
                </form>
                <PreContentHeader :show-loading="searchingForEmployee" :error-message="searchingForEmployeeError"></PreContentHeader>
                <transition name="grow">
                  <div v-if="showNominationForm || NominationTeamNames.length > 0">
                    <hr>
                    <strong>You are nominating:</strong><br>
                    <div>
                      <ul>
                        <li v-for="teams in NominationTeamNames" v-bind:key="teams.email">
                            <strong>{{teams.name}}</strong> from {{teams.country}} -
                            Employee number: <strong>{{teams.employeeNum}}</strong><br>
                            Department: <strong>{{teams.department}}</strong><br>
                            Company: <strong>{{teams.company}}</strong><br>
                            <button type="button" class="btn btn-link p-0" v-on:click="removeTeamNominee(teams)">X Remove</button>
                        </li>
                      </ul>
                    </div>
                    <hr>
                    <form v-on:submit.prevent=""><!-- Added OnSubmit; after few plugins update issues -->
                      <div v-for="formField in nominationFields" v-bind:key="formField.index">
                        <NominationField
                          :type="formField.type"
                          :description="formField.description"
                          :secondary-description="formField.secondaryDescription"
                          :description-lvl-two="formField.description_lvl_two"
                          :secondary-description-lvl-two="formField.secondary_description_lvl_two"
                          :is-required="formField.isRequired"
                          :checkbox-labels="formField.checkboxLabels"
                          v-on:updatedFieldContent="fieldUpdated($event)"
                          :validationMethod="formField.validationMethod"
                          :displayField="formField.display_field"
                          :error-class="formField.errorClass">
                        </NominationField>
                      </div>
                      <div class="row py-1">
                        <div class="col offset-md-4 offset-lg-4 offset-xl-3">
                          <div class="form-group form-check">
                            <input type="checkbox" class="form-check-input" id="terms" v-model="termsCheckbox" required>
                            <label for="terms" class="form-check-label">Nomination Complete. I accept the 
                              <router-link to="/page/innovation-terms-and-conditions/" target="_blank">Terms &amp; Conditions</router-link>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="row pt-2 mb-4">
                        <div class="col offset-md-4 offset-lg-4 offset-xl-3" v-if="submitClicked">
                          <button @click="submitNomination" type="submit" class="btn btn-primary btn-lg">Submit Nomination</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </transition>
                <PreContentHeader :show-loading="creatingNomination" :error-message="createNominationError"></PreContentHeader>
              </div>
            </div>
          </section>
          <div v-if="award.additional_content.length > 0 && award.additional_content[0] !== '' && award.additional_content !== ''" class="card mb-3">
            <div class="card-body" v-html="award.additional_content[0]"></div>
          </div>
        </div>
      </transition>
    </div>
  </template>
  
  <script>
  import ContentHeader from '@/components/ContentHeader'
  import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
//  import WordpressRestURI from '@/helpers/WordpressRestURI.js'
  import ADauthentication from '@/helpers/ADauthentication.js'
//  import NominationNotification from '@/helpers/NominationNotification.js'
  //import ChildNominationEventsList from '@/components/ChildNominationEventsList'
  import NominationField from '@/components/NominationField'
  //import Loading from '@/components/Loading'
  import PreContentHeader from '@/components/PreContentHeader'
  import vueBootstrapTypeahead from 'vue-bootstrap-typeahead'
  export default {
    data () {
      return {
        award: [],
        errors: [],
        contentReady: false,
        contentLoadError: '',
        nominationContent: [],
        nominationFields: [],
        nominatedPerson: '',
        madeNomination: false,
        termsCheckbox: false,
        validatedNominee: '',
        showNominationForm: false,
        creatingNomination: false,
        createNominationError: '',
        searchingForEmployee: false,
        searchingForEmployeeError: '',
        isContractorErrorSet: true,
        isTeamAwards: false,
        submitClicked: true,
        NominationButtonText: 'Nominate',
        NominationLabel: 'Nominate an Employee for this Award',
        NominationPlaceholder: 'Search by name and surname or email address...',
        NominationTeamNames: [],
        NominationTeamsContent: [],
        query: '',
        nomineesList: [],
        employeeHierarchy: {},
        awardFields: [{name: 'individual', fields: 'FieldCheckBoxesBehaviours, Field150Word, FieldFileInput'}, {name: 'team', fields: 'FieldCheckBoxesBehaviours, Field150Word, FieldFileInput, FieldSingleText'}]
      }
    },
    components: {
      PreContentHeader,
      ContentHeader,
      //ChildNominationEventsList,
      NominationField,
      //Loading,
      vueBootstrapTypeahead
    },
    methods: {
      setValidatedNominee: function (userData) {
        if (this.checkForDuplicateNominee(userData)) {
          let tempEmail = ''  
          if (userData.UPN && userData.UPN !== null && userData.UPN !== '') {
            tempEmail = userData.UPN
          } else {
            tempEmail = userData.email
          }
          this.validatedNominee = {
            name: userData.firstname + ' ' + userData.lastname,
            slug: userData.email.replace(/\./g, '-').replace(/@/g, '').toLowerCase(),
            department: userData.department,
            company: (userData.company === '') ? 'Multichoice' : userData.company,
            employeeNum: userData.employeehierarchy.employeenumber[0],
            country: userData.country,
            email: tempEmail,
            lineManagerName: (!userData.managername) ? userData.employeehierarchy['line-manager-name'][0] : userData.managername,
            lineManagerEmail: (!userData.manageremail) ? userData.employeehierarchy['line-manager-email'][0] : userData.manageremail,
            employeeHierarchy: userData.employeehierarchy
          }
          this.NominationTeamNames.push(this.validatedNominee)
          this.setNominationContent(this.award.nomination_fields[0][0])
        }
      },
      searchByEmail: function () {
        this.searchingForEmployeeError = ''
        ADauthentication.getUserInfoByEmail(this.nominatedPerson)
        .then(response => {
          console.log(response.data)
          if (response.data.ResponseCode === "400") {
            alert("User not found")
            this.nominatedPerson = ''
          } else {
            this.setValidatedNominee(response.data)
            this.showNominationForm = true
          }
          this.searchingForEmployee = false
          // this.validateContractors()
        })
        .catch(e => {
          if (this.isContractorErrorSet) {
            this.searchingForEmployee = false
            this.searchingForEmployeeError = 'We could not find a user with the email: ' + this.nominatedPerson + '. Make sure you entered the correct email address or try searching by name and surname'
          }
          this.isContractorErrorSet = true
          console.error(e)
        })
      },
      searchByUsername: function () {
        this.searchingForEmployeeError = ''
        ADauthentication.getUserInfoByUsername(this.nominatedPerson.replace(' ', '.').toLowerCase())
          .then(response => {
            this.setValidatedNominee(response.data)
            if (this.$store.getters.getUserEmail.toLowerCase() === response.data.email.toLowerCase()) {
              this.showNominationForm = false
              this.searchingForEmployee = false
              alert('You can\'t nominate yourself. Please nominate one of your colleagues instead.')
              this.searchingForEmployeeError = 'You can\'t nominate yourself. Please nominate one of your colleagues instead.'
            } else {
              this.showNominationForm = true
              this.searchingForEmployee = false
            }
          })
          .catch(e => {
            if (this.isContractorErrorSet) {
              this.searchingForEmployee = false
              this.searchingForEmployeeError = 'We could not find a user with the names: ' + this.nominatedPerson + '. Make sure you entered the correct name and surname or try searching by email'
            }
            this.isContractorErrorSet = true
            console.error(e)
          })
      },
      validateContractors: function () {
        if (this.$route.params.name !== 'employee-of-the-year-2018') {
          if (this.validatedNominee.employeeNum === 0 || this.validatedNominee.employeeNum === '0') {
            this.isContractorErrorSet = false
            this.showNominationForm = false
            this.searchingForEmployee = false
            this.searchingForEmployeeError = 'User names: ' + this.nominatedPerson + ' is a contractor and could not be nominated'
            throw new TypeError(this.searchingForEmployeeError)
          }
        }
      },
      checkForDuplicateNominee: function(data) {
        var self = this
        var dupliEmail = []
        if (self.$store.getters.getUserEmail.toLowerCase() === data.email.toLowerCase() || self.$store.getters.getUserName.toLowerCase() === data.firstname.toLowerCase() + ' ' + data.lastname.toLowerCase()) {
          dupliEmail.push(data.email)
          self.searchingForEmployeeError = 'You can\'t nominate yourself. Please nominate one of your colleagues instead.'
          return false
        }
        if (dupliEmail.length > 0) {
          self.searchingForEmployeeError = 'Duplicate Nominee ' + data.email
          return false
        }
        if (data.employeehierarchy) {
          if (data.employeehierarchy.ishod[0] ===  'Yes') {
            self.searchingForEmployeeError = 'SELECTED NOMINEE '  + data.email + ' IS HOD (OR ABOVE) AND CANNOT BE NOMINATED'
            return false
          }
        }
        else if (data.employeehierarchy === false) {
          self.searchingForEmployeeError = 'Nominee ' + data.email + ' is not present in Think Tank list. For further assistance, Please contact thinktank@multichoice.co.za'
          return false
        }
        return true
      },
      setNominee: function () {
        let val = this.nominatedPerson
        val = val.trim().toLowerCase()
        this.searchingForEmployee = true
        this.searchingForEmployeeError = ''
        var dupEmail = this.NominationTeamNames.filter(d => d.email.toLowerCase() === val)
        if (dupEmail.length > 0) {
            alert('Please add another nominee. Requested Nominee is already nominated ' + val)
            this.searchingForEmployee = false
        } else if (val !== '') {
            if (this.NominationTeamNames.length < 4) {
            if (this.nominatedPerson.indexOf('@') > -1) {
                if (this.$store.getters.getUserEmail.toLowerCase() !== this.nominatedPerson.toLowerCase()) {
                this.searchByEmail()
                } else {
                alert('You can\'t nominate yourself. Please nominate one of your colleagues instead.')
                this.searchingForEmployee = false
                }
            } else {
                if (this.$store.getters.getUserName.toLowerCase() !== this.nominatedPerson.toLowerCase()) {
                this.searchByUsername()
                } else {
                alert('You can\'t nominate yourself. Please nominate one of your colleagues instead.')
                this.searchingForEmployee = false
                }
            }
            } else {
            alert("You can only add upto max 4 nominee")
            this.searchingForEmployee = false
            }
        }
      },
      removeNominee: function () {
        this.validatedNominee = {name: '', department: '', employeeNum: ''}
        this.showNominationForm = false
        this.nominatedPerson = ''
        this.madeNomination = false
        this.submitClicked = true
      },
      removeTeamNominee: function (index) {
        this.NominationTeamNames.splice(this.NominationTeamNames.indexOf(index), 1)
        if (this.NominationTeamNames.length === 0) {
            this.showNominationForm = false
        }
        this.setNominationContent(this.award.nomination_fields[0][0])
      },
      setPostContent: function (type) {
        var content = ''
        var plainContent = ''
        for (var i = 0; i < this.nominationContent.length; i++) {
          if (this.nominationContent[i].displayField)
            if (this.nominationContent[i].label !== 'If applicable, please attach supporting documentation (Word, PowerPoint, video):' && this.nominationContent[i].label !== 'Project Sponsor Email' && this.nominationContent[i].label !== 'Choose Behaviour') {
              content += '<strong>' + this.nominationContent[i].label + '</strong><br><p>' + this.nominationContent[i].content + '</p>'
              plainContent += '<h>' + this.nominationContent[i].label + '<h> @#$% <c>' + this.nominationContent[i].content + '<c> @#$% '
            }
        }
        return (type === 'nohtml' ? plainContent : content)
      },
      ValidateFields: function (value, type, label) {
        if (type.toLowerCase() === 'email') {
          if (value.indexOf('@') === -1 || value.indexOf('.') === -1) {
            alert('Invalid ' + label + ' !')
            return false
          } else if (value.split('@').length > 2) {
            alert ('Only one mail allowed for ' + label + ' !' )
            return false
          }
          return true
        }
      },
      readyToSubmitNomination: function () {
        var contentPassedValidation = true
        this.searchingForEmployeeError = ''
        for (var j = 0; j < this.nominationContent.length; j++) {
          this.nominationFields[j].errorClass = ''
          if (this.nominationFields[j].display_field === false) {
            continue
          } else {
            if (this.nominationFields[j].validationMethod) {
              contentPassedValidation = this.ValidateFields(this.nominationContent[j].content, this.nominationFields[j].validationMethod, this.nominationContent[j].label)
            }
            if (this.nominationContent[j].required === 'false' && this.nominationContent[j].content === '' && !this.nominationContent[j].validated) {
              this.nominationContent[j].validated = true
            }
            if (this.nominationContent[j].validated === false) {
              contentPassedValidation = false
              this.nominationFields[j].errorClass = 'field-not-validated'
            }
            // Stop immedieatly any field validation is false
            if (contentPassedValidation === false)
              break;
          }
        }
        return this.termsCheckbox && contentPassedValidation
      },
      addMediaToNominationPost: function (mediaID, postID) {
        var sendNomination = {
          method: 'POST',
          data: {
            supporting_documentation: mediaID
          },
          headers: {
            'Authorization': localStorage.getItem('userToken'),
            'Content-Type': 'application/json'
          },
          json: true
        }
        WordpressRestAPI.endpointWithAuthetication(sendNomination, 'innovation_awards/' + postID)
          .then(function (response) {
            console.log(response)
          })
          .catch(function (e) {
            console.error(e)
          })
      },
      uploadSupportingDocumentation: function (postID, supportingDoc) {
        var self = this
        var formData = new FormData()
        formData.append('file', supportingDoc)
        formData.append('title', 'Supporting documentation for InnovationAwards ' + postID + '  ' + self.validatedNominee.name)
        formData.append('caption', 'Supporting documentation for InnovationAwards ' + postID + '  ' +  self.validatedNominee.name)
        if (self.isTeamAwards) {
          formData.append('title', 'Supporting documentation for Team by InnovationAwards ' + postID + '  ' +  self.$store.getters.getUserName)
          formData.append('caption', 'Supporting documentation for Team by InnovationAwards ' + postID + '  ' +  self.$store.getters.getUserName)
        }
        var uploadMedia = {
          method: 'POST',
          processData: false,
          contentType: false,
          data: formData,
          headers: {
            'Authorization': localStorage.getItem('userToken'),
            'Content-Type': 'application/json'
          },
          json: true
        }
        WordpressRestAPI.endpointWithAuthetication(uploadMedia, 'media')
          .then(function (response) {
            self.addMediaToNominationPost(response.data.id, postID)
          })
          .catch(function (e) {
            console.error(e)
          })
      },
      checkForMediaUpload: function (postID) {
        var supportingDoc = this.nominationContent.filter(x => {
          return x.label.indexOf('supporting documentation') > -1 && x.content !== ''
        })
        if (supportingDoc.length > 0) {
          this.uploadSupportingDocumentation(postID, supportingDoc[0].content)
        }
      },
      assignUserCommunities: function () {
        return this.award.community_categories.filter(
          f => this.$store.getters.getUserCommunityIDstring.split(',').map(x => parseInt(x)).includes(f)
        )
      },
      createNominationEntry: function () {
      this.showNominationForm = false
      this.creatingNomination = true
      var self = this
      var sendNomination = {
        method: 'POST',
        data: {
          title: "Innovation team awards, for "+self.$route.params.name+" by "+ self.$store.getters.getProfileDetails.name,
          is_team_award: true,
          nomination_event_category: self.award.nomination_event_category,
          community_categories: self.assignUserCommunities(),
          innovation_nominator_employee_number: self.validatedNominee.employeeNum,
          status: 'publish',
          content: self.setPostContent('html'),
          innovation_nominationdata: self.setPostContent('nohtml'),
        },
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }
      if (self.NominationTeamNames.length > 0) {
        sendNomination.data.innovation_awards_nominee = []
        for (var i = 0; i < self.NominationTeamNames.length; i++) {
          sendNomination.data.innovation_awards_nominee.push({
            'innovation_nominee_name': self.NominationTeamNames[i].name,
            'innovation_employee_number': self.NominationTeamNames[i].employeeNum,
            'innovation_nominee_email': self.NominationTeamNames[i].email
          })
        }
      }
      console.log('NOms data', sendNomination)
      WordpressRestAPI.endpointWithAuthetication(sendNomination, 'innovation_awards')
        .then(function (response) {
          self.checkForMediaUpload(response.data.id)
          // Add Mail notification here
          self.madeNomination = true
          self.creatingNomination = false
        })
        .catch(function (e) {
          self.createNominationError = 'Oops! We had a problem adding your nomination. Please try again later.'
          console.error(e)
        })
      },
      submitNomination: function () {
        this.submitClicked = false
        if (this.readyToSubmitNomination()) {
          this.createNominationEntry()
        } else {
          this.submitClicked = true
        }
      },
      fieldUpdated: function (fieldDetails) {
        for (var i = 0; i < this.nominationContent.length; i++) {
          if (this.nominationContent[i].label === fieldDetails.label) {
            this.nominationContent[i].content = fieldDetails.content
            this.nominationContent[i].validated = fieldDetails.validated
            this.nominationContent[i].displayField = fieldDetails.displayField
            if (fieldDetails.label === 'Choose Behaviour') {
              this.nominationContent[i].parentcategory = fieldDetails.parentcategory
              this.nominationContent[i].parentName = fieldDetails.parentName
            }
            break
          }
        }
      },
      setNominationContent: function (nominationFields) {
        var self = this
        self.nominationFields = nominationFields.map(function (x, index) {
          var displayFieldVal = x.display_field === "No" ? false : true
          var fieldDescriptionVal = x.field_description
          var FieldSecondaryDescriptionVal = x.field_secondary_description
  
          return {
            type: x.form_field_type,
            description: fieldDescriptionVal,
            secondaryDescription: FieldSecondaryDescriptionVal,
            isRequired: x.required_nomination_field,
            checkboxLabels: x.checkbox_labels,
            errorClass: '',
            index: index + x.form_field_type,
            description_lvl_two: x.description_lvl_two,
            secondary_description_lvl_two: x.secondary_description_lvl_two,
            display_field: displayFieldVal,
            validationMethod: x.validationmethod
          }
        })
  
        if (self.nominationContent.length > 1) {
          self.nominationContent = self.nominationFields.map(function (x, i) {
            return {label: x.description, content: self.nominationContent[i].content, required: x.isRequired, validated: false, displayField: x.displayField}
          })
        } else  {
          self.nominationContent = self.nominationFields.map(function (x) {
            return {label: x.description, content: '', required: x.isRequired, validated: false, displayField: x.displayField}
          })
        }
      },
      loadContent: function () {
        this.madeNomination = false
        this.nominatedPerson = ''
        document.title = this.$route.name + ' - ThinkTank'
        WordpressRestAPI.getViewContent('nomination_event?slug=' + this.$route.params.name + '&_embed')
        .then(response => {
          this.award = response.data[0]
          //this.award = ''
          this.contentReady = true
          if (this.award.include_nomination_form[0] === 'Yes') {
            // Reinitiate every variable related with form
            this.isTeamAwards = true
            this.NominationButtonText = 'Add Nominee'
            this.NominationLabel = 'Nominate an Employee for this Award'
            this.NominationPlaceholder = 'Search by name and surname or email address...'
            this.setNominationContent(this.award.nomination_fields[0][0])
          }
        })
        .catch(e => {
          this.contentLoadError = 'Oops! We had a problem with loading this Recognition. Please try again later.'
          console.error(e)
          this.contentReady = true
        })
      },
      searchNomineeList: function (newQuery) {
        if ( newQuery.length > 2 )
        WordpressRestAPI.getCustomViewContent('getNominees/v1/nomineelist?search=' + newQuery)
          .then((res) => {
            this.nomineesList = res.data
          })
      }
    },
    created () {
      this.loadContent()
    },
    watch: {
      nominatedPerson (newQuery, oldQuery) { 
        console.log(' nomination changed ', oldQuery, newQuery)
        if (oldQuery === newQuery)
        console.log(' nomination changed ', oldQuery, newQuery)
        if (newQuery != '')
          this.searchNomineeList(newQuery) 
      },
      '$route' (to, from) {
        console.log(to, from)
        this.contentReady = false
        this.loadContent()
      }
    }
  }
  </script>
  
  <style lang="less">
    .featuredImg {
      img {
        width: 100%;
      }
    }
  </style>


// WEBPACK FOOTER //
// src/components/routes/InnovationAwards.vue